module.exports = __webpack_public_path__ + "static/media/Cyber.271eb230.svg";